import transferVoipCall from './transferVoipCall';

export default transferVoipCall;
